import React, { useContext, useEffect, useRef, useState } from 'react'

import { InfoOutlined } from '@ant-design/icons';
import { Button, Popover, Tour } from 'antd'
import { LOCAL_AUDIENCE_CREATE_FIRST_OPEN } from '../../helpers/Globals';

export default function DiMarketingAudienceTour({context}) {

   const [open, setOpen] = useState(false);

   const refMarketingTourButton = useRef(null);
   
   const backLabel = "Indietro";
   const nextLabel = "Avanti";

   const {
      diAppRef,
   } = context;
  
   const steps = [
      {
         title: 'Benvenuto nella creazione del tuo Pubblico',
         description: 'Segmenta il tuo pubblico con diversi parametri, in modo da poter comunicare con loro in modo automatizzato e smart!',
         cover: (
          <img
            alt="Audience"
            src="/audience.svg"
            height={"350px"}
          />
        ),
         prevButtonProps: {
            children: backLabel, 
         },
         nextButtonProps: {
            children: nextLabel,
         },
      },
      {
         title: 'Pubblico Potenziale',
         description: 'Cliccando su aggiorna dopo aver impostato dei filtri, potrai vedere il tuo pubblico potenziale prima di salvare',
         target: () => diAppRef.refPotentialAudience.current,
         prevButtonProps: {
            children: backLabel, 
         },
         nextButtonProps: {
            children: nextLabel,
         },
      },
      {
         title: 'I preset più usati',
         description: 'Qui troverai i preset di filtri più utilizzati per segmentare il pubblico nella nostra piattaforma... Provane uno subito!',
         target: () => diAppRef.refTopAudiencesCarousel.current,
         prevButtonProps: {
            children: backLabel, 
         },
         nextButtonProps: {
            children: nextLabel,
         },
      },
      {
         title: 'Attiva un preset',
         description: 'Cliccando qui attiverai il preset, attenzione però sostituirai integralmente eventuali filtri impostati!',
         target: () => diAppRef.refTopAudiencesButton.current,
         prevButtonProps: {
            children: backLabel, 
         },
         nextButtonProps: {
            children: nextLabel,
         },
      },
      {
         title: 'Gruppi di filtri',
         description: 'Tutti i dati degli utenti sono divisi in categorie, ogni dato per sezione si relazionerà con gli altri per proporre il pubblico secondo i tuoi desideri',
         target: () => diAppRef.refAudienceTabsHeader.current,
         prevButtonProps: {
            children: backLabel, 
         },
         nextButtonProps: {
            children: nextLabel,
         },
      },
      {
         title: 'Aggiungi i filtri',
         description: 'Espandendo una qualsiasi sezione potrai aggiungere quante combinazioni di dati vorrai per individuare il pubblico',
         target: () => diAppRef.refAudienceNameSection.current,
         prevButtonProps: {
            children: backLabel, 
         },
         nextButtonProps: {
            children: nextLabel,
         },
      },
      {
         title: 'Aggiungi il filtro!',
         description: 'In ogni area clicca questo tasto per aggiungere quanti filtri vuoi per questo dato specifico e configurarlo',
         target: () => diAppRef.refAudienceAddData.current,
         prevButtonProps: {
            children: backLabel, 
         },
         nextButtonProps: {
            children: nextLabel,
         },
      },
      {
         title: 'Salva il tuo pubblico!',
         description: 'Una volta soddisfatto dei tuoi filtri di pubblico, salva inserendo un titolo ed una descrizione, così da ricordarti perché lo hai creato. E preparati ad attivare delle operazioni!',
         target: () => diAppRef.refAudienceSave.current,
         prevButtonProps: {
            children: backLabel, 
         },
         nextButtonProps: {
            children: nextLabel,
         },
      },
      {
         title: 'Ripeti il tour quando vuoi',
         description: 'Puoi cliccare questo tasto ogni qualvolta avrai bisogno di informazioni!',
         target: () => refMarketingTourButton.current,
         prevButtonProps: {
            children: backLabel, 
         },
         nextButtonProps: {
            children: "Fine",
         },
      },
   ];

   /////////////////////////////////////////////////////////////////////////////////////////// 
   // dopo la prima volta salvo che è stato aperto già in modo da non mostrare il tour //
   ///////////////////////////////////////////////////////////////////////////////////////////

   useEffect(() => {
      
      setTimeout(() => {
         setOpen(localStorage.getItem(LOCAL_AUDIENCE_CREATE_FIRST_OPEN) ? false : true)
         localStorage.setItem(LOCAL_AUDIENCE_CREATE_FIRST_OPEN, true)
      }, 1000);

   },[])
   
   /////////////////////////////////////////////////////////////////////////////////////////// 
   // dopo la prima volta salvo che è stato aperto già in modo da non mostrare il tour //
   /////////////////////////////////////////////////////////////////////////////////////////// 
  
   return (
     <>
          <Popover title="Tour del pubblico">
            <Button
               onClick={() => setOpen(true)}
               ref={diAppRef.refMarketingTourButton}
               icon={<InfoOutlined />}
               shape='circle'
           />
         </Popover>
         <Tour
            onClose={() => setOpen(false)}
            steps={steps}
            open={open}
         />
     </>
  )
}
